<template>
  <b-collapse class="evaluation-card" animation="slide" :open="isOpen" data-cy="gops-data">
    <template #trigger="{ open }">
      <header class="card-header" role="button" :aria-expanded="open.toString()">
        <p class="card-header-title">
          GOPs asociados
        </p>
        <a class="card-header-icon">
          <b-icon :icon="open ? 'minus' : 'plus'" />
        </a>
      </header>
    </template>
    <section class="card-block p-0 pt-1">
      <div class="subcard is-gray">
        <div class="subcard-header">
          <p class="header-title">Gastos operacionales</p>
          <b-button
            class="header-icon"
            size="is-small"
            :icon-left="propertiesValues ? 'angle-up' : 'angle-down'"
            @click="togglePropertiesValues" />
        </div>

        <div v-if="propertiesValues" class="subcard-content fields-has-text-right">
          <BInputExpanded
            v-model="simulation.offerResponse.operationalExpenses"
            :disabled="readOnly"
            label="Total de gastos operacionales"
            placeholder="Ingresa valor en UF"
            prefix="UF"
            size="is-small"
            prefix-position="left" />

          <BInputExpanded
            v-model="simulation.offerResponse.titleStudyExpenses"
            :disabled="readOnly"
            label="Estudio de títulos"
            placeholder="Ingresa valor en UF"
            prefix="UF"
            size="is-small"
            prefix-position="left" />

          <BInputExpanded
            v-model="simulation.offerResponse.appraisalExpenses"
            :disabled="readOnly"
            label="Tasación"
            placeholder="Ingresa valor en UF"
            prefix="UF"
            size="is-small"
            prefix-position="left" />

          <BInputExpanded
            v-model="simulation.offerResponse.deedExpenses"
            :disabled="readOnly"
            label="Escrituración"
            placeholder="Ingresa valor en UF"
            prefix="UF"
            size="is-small"
            prefix-position="left" />

          <BInputExpanded
            v-model="simulation.offerResponse.notaryExpenses"
            :disabled="readOnly"
            label="Notaria"
            placeholder="Ingresa valor en UF"
            prefix="UF"
            size="is-small"
            prefix-position="left" />

          <BInputExpanded
            v-model="simulation.offerResponse.registrationExpenses"
            :disabled="readOnly"
            label="Inscripción"
            placeholder="Ingresa valor"
            prefix="%"
            size="is-small"
            prefix-position="left" />

          <BInputExpanded
            v-model="simulation.offerResponse.creditTaxExpenses"
            :disabled="readOnly"
            label="Impuesto al mutuo"
            placeholder="Ingresa valor"
            prefix="%"
            size="is-small"
            prefix-position="left" />
        </div>
      </div>

      <div class="subcard">
        <BInputExpanded
          :value="calculateRebajasConvenios()"
          :disabled="readOnly"
          label="Rebajas o convenios"
          placeholder="Ingresa valor en UF"
          prefix="UF"
          size="is-small"
          prefix-position="left" />

        <BInputExpanded
          v-model="simulation.offerResponse.operationalExpensesFinanced"
          :disabled="readOnly"
          label="Financiados en crédito"
          placeholder="Ingresa valor en UF"
          prefix="UF"
          size="is-small"
          prefix-position="left" />

        <BInputExpanded
          v-model="simulation.offerResponse.operationalExpensesFee"
          :disabled="readOnly"
          label="Cuota fuera de crédito"
          placeholder="Ingresa valor en UF"
          prefix="UF"
          size="is-small"
          prefix-position="left" />

        <BInputExpanded
          v-model="depositedByClient"
          :disabled="readOnly"
          label="A depositar por cliente"
          placeholder="Ingresa valor en UF"
          prefix="UF"
          size="is-small"
          prefix-position="left" />
      </div>
    </section>
  </b-collapse>
</template>

<script>
import { mapState } from 'vuex';
import BInputExpanded from '@/ui/components/input/BInputExpanded.vue';

export default {
  name: 'GopsCard',
  components: { BInputExpanded },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      propertiesValues: false,
      depositedByClient: 0
    };
  },
  computed: {
    ...mapState('evaluation', ['simulation'])
  },
  mounted() {
    this.calculateDepositedByClient();
  },
  methods: {
    togglePropertiesValues() {
      this.propertiesValues = !this.propertiesValues;
    },
    calculateDepositedByClient() {
      this.depositedByClient = (this.simulation.offerResponse.operationalExpenses - (this.simulation.offerResponse.notaryExpenses - this.simulation.offerResponse.creditTaxExpenses)).toFixed(2);
    },
    calculateRebajasConvenios() {
      return (this.simulation.offerResponse.operationalExpenses
        - (this.simulation.offerResponse.titleStudyExpenses
          + this.simulation.offerResponse.appraisalExpenses
          + this.simulation.offerResponse.deedExpenses
          + this.simulation.offerResponse.notaryExpenses
          + this.simulation.offerResponse.registrationExpenses
          + this.simulation.offerResponse.creditTaxExpenses
        )).toFixed(2);
    }
  }
};
</script>

<style scoped>

.collapse-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 1rem;
}
</style>
